import { useParams } from "react-router-dom";

export const useSlugs = () => {
  const {brandSlug, locationSlug} = useParams();

  return {
    brandSlug: brandSlug ?? "",
    locationSlug: locationSlug ?? ""
  };
};
